import { render } from "./Verificar.vue?vue&type=template&id=630ea866&scoped=true"
import script from "./Verificar.vue?vue&type=script&lang=js"
export * from "./Verificar.vue?vue&type=script&lang=js"

import "./Verificar.vue?vue&type=style&index=0&id=630ea866&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630ea866"]])

export default __exports__